import React from 'react';
import Tableau from './Tableau.react';

const MyUniverses = () => (
  <Tableau
    workbookLabel='Universes'
    reportsFilter={reports =>
      reports.filter(wb => wb.name.startsWith('MyUniverses-'))
             .map(wb => wb.set('name', wb.name.slice('MyUniverses-'.length)))}
  />);

export default MyUniverses;
